import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { StyledLabel } from './label.style.js';

const Label = props => {
    const { children, className = '', color = 'primary', disabled = false, fontFamily = 'regular', fontSize = 500, htmlFor, lineHeight = 'small', margin, opacity = 'high', required } = props, rest = __rest(props, ["children", "className", "color", "disabled", "fontFamily", "fontSize", "htmlFor", "lineHeight", "margin", "opacity", "required"]);
    return (jsxs(StyledLabel, Object.assign({ className: className, color: color, disabled: disabled, fontFamily: fontFamily, fontSize: fontSize, htmlFor: htmlFor, lineHeight: lineHeight, margin: margin, opacity: opacity }, rest, { children: [children, required && jsx("sup", { children: "*" }, void 0)] }), void 0));
};

export { Label };
